import React, { Component } from 'react';
import { Button, Theme, Typography, WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { MyPATDialog } from '../../../common';
import cx from 'classnames';
import { CHARACTER_LIMIT, MAXIMUM_REVIEW_CHARACTERS } from '../../constant/content';
import CustomInfoIcon from '../../../common/CustomInfoIcon';

const styles = (theme: Theme) => 
    createStyles({
        dialogCustomHeading: {
            fontSize: '1.5rem',
            fontWeight: 600,
            lineHeight: '138%',
            color: '#333333',
            textTransform: 'initial',
        },
        buttonSection: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            '& button': {
                minWidth: '7.25rem',
                minHeight: '44px',
                fontWeight: 400,
                fontSize: '1rem',
            }
        },
        rateReviewSection: {
            maxHeight: '373px',
            '& .disclaimer': {
                padding: '0.94rem 1.25rem',
                marginBottom: '1.25rem',
                backgroundColor: '#FFF8E8',
                borderRadius: '0.5rem',
                fontSize: '0.88rem',
                fontWeight: 500,
                lineHeight: '150%',
                color: '#666666',
                display: 'flex',
                gap: '0.19rem',
                '& svg': {
                    marginTop: '1px',
                    minWidth: '1.13rem',
                }
            },
            '& .rate-review-form-section': {
                paddingBottom: '30px',
                '& .form-group': {
                    marginBottom: '0.94rem',
                    '& label': {
                        marginBottom: '0.63rem',
                        fontSize: '0.88rem',
                        fontWeight: 500,
                        lineHeight: '136%',
                        color: '#666666',
                        display: 'flex',
                        alignItems: 'center',
                        '& .light-text': {
                            color: '#999999',
                        },
                        '& .info-icon': {
                            marginLeft: '0.19rem',
                            '& svg': {
                                display: 'block',
                            }
                        }
                    },
                    '& textarea': {
                        border: '1px solid #ECECEC',
                        borderRadius: '0.25rem',
                        height: '6.31rem',
                        fontSize: '0.88rem',
                        fontWeight: 400,
                        color: '#333333',
                        width: '100%',
                        resize: 'none',
                        padding: '0.75rem 0.75rem',
                        fontFamily: '"Nunito", sans-serif',
                        '&::placeholder': {
                            color: '#999999',
                        },
                        '&:focus': {
                            outline: 'none',
                        }
                    },
                    '& .note-text': {
                        fontSize: '0.75rem',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: '0.88rem',
                        color: '#999999',
                        display: 'block',
                        textAlign: 'right',
                    }
                },
            },
            '& .slider-panel': {
                border: '1px solid #ECECEC',
                backgroundColor: '#FCFCFC',
                padding: '3.75rem 0.94rem 1.56rem',
                overflowX: 'hidden',
                borderRadius: '0.25rem',
            },
            '& .range-slider': {
                position: 'relative',
                height: '0.38rem',
                '& input[type="range"]': {
                    WebkitAppearance: 'none',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    borderRadius: '0.31rem',
                    outline: 'none',
                    margin: '0',
                    background: '#DBECFF',
                    cursor: 'pointer',
                },
                '& .slider::-webkit-slider-thumb': {
                    WebkitAppearance: 'none',
                    appearance: 'none',
                    width: '1.38rem',
                    height: '1.38rem',
                    border: '1px solid #E6E6E6',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    opacity: 1,
                    position: 'relative',
                    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.10)',
                    backgroundImage: 'url(/assets/svg/contentValidation/slider-thumb-ic.svg)',
                    backgroundSize: 'auto',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    zIndex: 2,
                },
                '& .slider-effect': {
                    top: '0',
                    left: '0',
                    height: '100%',
                    position: 'absolute',
                    backgroundColor: '#1D7DEA',
                    borderRadius: '0.63rem',
                    pointerEvents: 'none',
                }
            },
            '& .slider-number': {
                display: 'flex',
                listStyle: 'none',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingLeft: '0',
                position: 'absolute',
                width: '99%',
                left: '0',
                right: '0',
                top: '-2.69rem',
                margin: '0 auto',
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '1rem',
                color: '#999999',    
                '& li': {
                    width: '0.94rem',
                    textAlign: 'center',
                    position: 'relative',
                    '&::before': {
                        width: '0.38rem',
                        height: '0.38rem',
                        bottom: '-0.56rem',
                        content: "''",
                        position: 'absolute',
                        borderRadius: '1px',
                        backgroundColor: '#1D7DEA',
                        transform: 'translateX(-50%) rotate(45deg)',
                        left: '50%',
                        opacity: 0,
                    },
                    '&::after': {
                        content: "''",
                        width: '2.25rem',
                        height: '1.38rem',
                        fontSize: '0.63rem',
                        fontWeight: 700,
                        lineHeight: '0.81rem',
                        color: '#ffffff',
                        backgroundColor: '#1D7DEA',
                        borderRadius: '0.75rem',
                        textAlign: 'center',
                        opacity: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'absolute',
                        left: '50%',
                        top: '0px',
                        transform: 'translateX(-50%)',
                        boxShadow: '0rem 0.25rem 0.63rem 0rem rgba(29, 125, 234, 0.15)',
                    }
                }            
            },
            '& input[type="range"]': {
                '&[value="10"]': {
                    '& + .slider-effect': {
                        width: '100%',
                    },
                    '& ~ .slider-number li:nth-child(10)': {
                        '&::after': {
                            opacity: 1,
                            content: "'10'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="9"]': {
                    '& + .slider-effect': {
                        width: 'calc(90% - 0.94rem)',
                    },
                    '& ~ .slider-number li:nth-child(9)': {
                        '&::after': {
                            opacity: 1,
                            content: "'9'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="8"]': {
                    '& + .slider-effect': {
                        width: 'calc(80% - 0.94rem)',
                    },
                    '& ~ .slider-number li:nth-child(8)': {
                        '&::after': {
                            opacity: 1,
                            content: "'8'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="7"]': {
                    '& + .slider-effect': {
                        width: 'calc(70% - 0.94rem)',
                    },
                    '& ~ .slider-number li:nth-child(7)': {
                        '&::after': {
                            opacity: 1,
                            content: "'7'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="6"]': {
                    '& + .slider-effect': {
                        width: 'calc(60% - 0.94rem)',
                    },
                    '& ~ .slider-number li:nth-child(6)': {
                        '&::after': {
                            opacity: 1,
                            content: "'6'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="5"]': {
                    '& + .slider-effect': {
                        width: 'calc(50% - 1.88rem)',
                    },
                    '& ~ .slider-number li:nth-child(5)': {
                        '&::after': {
                            opacity: 1,
                            content: "'5'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="4"]': {
                    '& + .slider-effect': {
                        width: 'calc(40% - 1.88rem)',
                    },
                    '& ~ .slider-number li:nth-child(4)': {
                        '&::after': {
                            opacity: 1,
                            content: "'4'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="3"]': {
                    '& + .slider-effect': {
                        width: 'calc(30% - 1.88rem)',
                    },
                    '& ~ .slider-number li:nth-child(3)': {
                        '&::after': {
                            opacity: 1,
                            content: "'3'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="2"]': {
                    '& + .slider-effect': {
                        width: 'calc(20% - 1.88rem)',
                    },
                    '& ~ .slider-number li:nth-child(2)': {
                        '&::after': {
                            opacity: 1,
                            content: "'2'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
                '&[value="1"]': {
                    '& + .slider-effect': {
                        width: '0%',
                    },
                    '& ~ .slider-number li:nth-child(1)': {
                        '&::after': {
                            opacity: 1,
                            content: "'1'",
                        },
                        '&::before': {
                            opacity: 1,
                        }
                    }
                },
            },
            
        },
        limitExceed: {
            borderColor: "#EC1C24 !important",
            background: "#FFF3F3"
        },
        textRed: {
            color: "#EC1C24 !important",
        }
    });

interface RateQuestionModalProps extends WithStyles<typeof styles> {
    classes: any,
    isRateQuestionModalOpen: boolean,
    handleRateQuestionClose: Function,
    onContentRatingSubmit: Function,
    isValidatorRating: boolean,
}

interface RateQuestionModalStates {
    articulationRating: number;
    innovationRating: number;
    ratingScale: number[];
    reviewText: string;
}

class RateQuestionModal extends Component<RateQuestionModalProps, RateQuestionModalStates> {
    constructor(props: RateQuestionModalProps) {
        super(props);
        this.state = {
            articulationRating: 0,
            innovationRating: 0,
            ratingScale: Array.from({ length: 10 }, (_, index) => index + 1),
            reviewText: '',
        };
    }

    handleRatingSubmit = () => {
        const {innovationRating, articulationRating, reviewText} = this.state;
        const rating = {
            articulation: articulationRating,
            innovation: innovationRating,
            review: reviewText,
        }
        this.props.onContentRatingSubmit(rating);
    }

    onModalClose = () => {
        this.setState({
            articulationRating: 0,
            innovationRating: 0,
            reviewText: '',
        });
        this.props.handleRateQuestionClose();
    }

    render() {
        const { classes, isRateQuestionModalOpen, isValidatorRating } = this.props;
        const { articulationRating, innovationRating, ratingScale, reviewText } = this.state;
        return (
            <MyPATDialog
                dialogHeading={
                    <>
                      <span className={classes.dialogCustomHeading}>Rate and Review</span>
                    </>
                  }
                dialogOpen={isRateQuestionModalOpen}
                dialogHasActions={false}
                onDialogClose={this.onModalClose}
                customButtonVariant="withoutBorderCloseIcon"
                isAlignCenter={true}
                stopParentScroll={false}
                otherDialogProps={{
                    fullWidth: true,
                    maxWidth: 'sm',
                    scroll: 'body'
                }}
                customDialogActions={
                    <>
                      <div className={classes.buttonSection}>
                        <Button
                          className={classes.primaryBtn}
                          autoFocus
                          variant="contained"
                          color="primary"
                          disabled={!(articulationRating && innovationRating) || reviewText.length > MAXIMUM_REVIEW_CHARACTERS}
                          onClick={this.handleRatingSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </>
                  }
            >
                <div className={classes.rateReviewSection}>
                    <div className='disclaimer'>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.42779 11.0999C9.4176 11.2064 9.36809 11.3052 9.28893 11.3772C9.20976 11.4491 9.10662 11.489 8.99964 11.489C8.89266 11.489 8.78952 11.4491 8.71035 11.3772C8.63119 11.3052 8.58168 11.2064 8.57149 11.0999L8.15507 5.9855C8.14568 5.86871 8.16064 5.75123 8.199 5.64051C8.23737 5.52979 8.2983 5.42825 8.37794 5.3423C8.4572 5.25653 8.55335 5.18809 8.66034 5.14128C8.76734 5.09448 8.88286 5.07031 8.99964 5.07031C9.11642 5.07031 9.23194 5.09448 9.33894 5.14128C9.44593 5.18809 9.54208 5.25653 9.62134 5.3423C9.70098 5.42825 9.76192 5.52979 9.80028 5.64051C9.83864 5.75123 9.85361 5.86871 9.84422 5.9855L9.42779 11.0999ZM8.99964 13.9278C8.86972 13.9278 8.74272 13.8893 8.63469 13.8171C8.52667 13.7449 8.44247 13.6424 8.39275 13.5223C8.34303 13.4023 8.33003 13.2702 8.35537 13.1428C8.38072 13.0154 8.44328 12.8983 8.53515 12.8064C8.62702 12.7146 8.74406 12.652 8.87149 12.6267C8.99891 12.6013 9.13099 12.6143 9.25102 12.664C9.37105 12.7138 9.47365 12.798 9.54583 12.906C9.61801 13.014 9.65653 13.141 9.65653 13.2709C9.65653 13.4452 9.58732 13.6122 9.46413 13.7354C9.34094 13.8586 9.17386 13.9278 8.99964 13.9278Z" fill="#FCB705"/>
                            <path d="M9.42779 11.0999C9.4176 11.2064 9.36809 11.3052 9.28893 11.3772C9.20976 11.4491 9.10662 11.489 8.99964 11.489C8.89266 11.489 8.78952 11.4491 8.71035 11.3772C8.63119 11.3052 8.58168 11.2064 8.57149 11.0999L8.15507 5.9855C8.14568 5.86871 8.16064 5.75123 8.199 5.64051C8.23737 5.52979 8.2983 5.42825 8.37794 5.3423C8.4572 5.25653 8.55335 5.18809 8.66034 5.14128C8.76734 5.09448 8.88286 5.07031 8.99964 5.07031C9.11642 5.07031 9.23194 5.09448 9.33894 5.14128C9.44593 5.18809 9.54208 5.25653 9.62134 5.3423C9.70098 5.42825 9.76192 5.52979 9.80028 5.64051C9.83864 5.75123 9.85361 5.86871 9.84422 5.9855L9.42779 11.0999Z" fill="#FCB705"/>
                            <path d="M8.99964 13.9278C8.86972 13.9278 8.74272 13.8893 8.63469 13.8171C8.52667 13.7449 8.44247 13.6424 8.39275 13.5223C8.34303 13.4023 8.33003 13.2702 8.35537 13.1428C8.38072 13.0154 8.44328 12.8983 8.53515 12.8064C8.62702 12.7146 8.74406 12.652 8.87149 12.6267C8.99891 12.6013 9.13099 12.6143 9.25102 12.664C9.37105 12.7138 9.47365 12.798 9.54583 12.906C9.61801 13.014 9.65653 13.141 9.65653 13.2709C9.65653 13.4452 9.58732 13.6122 9.46413 13.7354C9.34094 13.8586 9.17386 13.9278 8.99964 13.9278Z" fill="#FCB705"/>
                            <circle cx="9" cy="9" r="6.6" stroke="#FCB705" stroke-width="0.8"/>
                        </svg>
                        {isValidatorRating ?
                        <span>Note: The ratings and review provided by you will be publicly visible to everyone on the platform (anonymously) once the question is published</span> :
                        <span>Note: The ratings and review provided will be publicly visible to everyone.</span>
                        }
                    </div>
                    

                    <div className='rate-review-form-section'>
                        <div className='form-group'>
                            <label>
                                Articulation
                                <CustomInfoIcon
                                    isCenterArrow={true}
                                    isRightArrow={false}
                                    isInfoIcon={true}
                                    knowMoreAbout={false}
                                    dialogTitle="Articulation"
                                    dialogPara="Articulation refers to the clarity and eloquence with which questions are expressed. It involves the use of language in a precise and articulate manner to convey ideas effectively."
                                    details="Click to know more"
                                    toolTipDirection="top" />
                            </label>

                            <div className='slider-panel'>
                                <div className='range-slider'>
                                    <input className='slider' id='slider1' type="range" min={1} max={10} step={1} value={articulationRating} onChange={(e) => {this.setState({articulationRating: +e.target.value});}} />
                                    <span className='slider-effect'></span>
                                    <ul className='slider-number'>
                                        {ratingScale.map((rating, index) => <li key={index}>{rating}</li>)}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='form-group'>
                            <label>
                                Innovation
                                <CustomInfoIcon
                                    isCenterArrow={true}
                                    isRightArrow={false}
                                    isInfoIcon={true}
                                    knowMoreAbout={false}
                                    dialogTitle="Innovation"
                                    dialogPara="Innovation involves introducing novel or creative elements into question, fostering engagement and stimulating critical thinking"
                                    details="Click to know more"
                                    toolTipDirection="top" />
                            </label>

                            <div className='slider-panel'>
                                <div className='range-slider'>
                                    <input className='slider' id='slider2' type="range" min={1} max={10} step={1} value={innovationRating} onChange={(e) => {this.setState({innovationRating: +e.target.value});}} />
                                    <span className='slider-effect'></span>
                                    <ul className='slider-number'>
                                    {ratingScale.map((rating, index) => <li key={index}>{rating}</li>)}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='form-group'>
                            <label>
                                Please share your review <span className='light-text'>(Optional)</span>
                            </label>
                            <textarea className={cx({[classes.limitExceed]: reviewText.length > MAXIMUM_REVIEW_CHARACTERS})} placeholder='Please type here' value={reviewText} onChange={(event: any) => this.setState({reviewText: event.target.value})}></textarea>
                            <em className={cx('note-text', {[classes.textRed]: reviewText.length > MAXIMUM_REVIEW_CHARACTERS})}>{reviewText.length > MAXIMUM_REVIEW_CHARACTERS ? CHARACTER_LIMIT.ERROR : CHARACTER_LIMIT.INFO }</em>
                        </div>
                    </div>
                </div>
            </MyPATDialog>
        )
    }
}

// @ts-ignore
export default (withStyles(styles)(RateQuestionModal));